import { useSetFieldValue } from '@/shared/useSetFieldValue'
import { ANALYTICS_EVENT, useAnalytics } from '@/sharedComposables/useAnalytics'
import type { Field } from './Fields/types'
import type { Entity } from './types'
import { useFieldUpload } from './useFieldUpload'

/**
 * Handles clearing of the manual value from a file field,
 * by both clearing the field and deleting the actual file from the storage provider.
 */
export const useFieldDeleteFile = () => {
  const { captureAnalyticsEvent } = useAnalytics()

  const uploadStore = useFieldUpload()

  const setFieldValue = useSetFieldValue()

  const deleteFile = async ({
    field,
    parentEntityId,
  }: {
    field: Field<'file' | 'file_collection' | 'data'>
    parentEntityId?: Entity['parentEntityId']
  }) => {
    const entityId = field.entityId
    const propertyId = field.propertyId

    // if the file is being uploaded, remove it from the upload queue
    // before deleting it
    if (field.status == 'uploading') {
      uploadStore.removeUpload({
        workspaceId: field.workspaceId,
        projectId: field.projectId,
        entityId,
        propertyId,
        parentEntityId: parentEntityId || null,
      })
    }

    const fields = { [propertyId]: { field, newValue: null } }

    const res = await setFieldValue(fields)

    if (res.ok) {
      captureAnalyticsEvent(ANALYTICS_EVENT.FILE_DELETED)
    }
  }

  return { deleteFile }
}
